import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Indicator } from "./models/SouthernWatersModels";

export default class SouthernWaterVuexModule extends AbacoVuexModule {
    @State() selectedIndicator!: Indicator | null;

    @State() plotColors!: {plot_id: number; color: string}[];
}
